import React, {useEffect, useRef, useState} from 'react';
import ExtractionProvider from "@/pages/takeoff/layouts/extraction/context/extraction-provider.tsx";

import ExtractionCard from './components/extraction-card.tsx';
import SelectionCard, { SelectionCardRef } from './components/selection-card.tsx';
import ExtractionViewerContainer, { ExtractionViewerContainerRef } from './components/extraction-viewer-container.tsx';
import useExtractionContext from "@/pages/takeoff/layouts/extraction/context/use-extraction-context.ts";
import usePreventNavigationContext from "@/services/context/prohibit-nagivation/use-prevent-navigation-context.ts";

const ExtractionComponent: React.FC = () => {
    
    const {isDirty, isSaving} = useExtractionContext();
    const { setIsNavigationPrevented } = usePreventNavigationContext();
    
    const selectionCardRef = useRef<SelectionCardRef>(null);
    const extractionViewerContainerRef = useRef<ExtractionViewerContainerRef>(null);
    
    const [isViewerLoading, setIsViewerLoading] = useState(false);
    
    useEffect(() => {
        setIsNavigationPrevented(isDirty || isSaving);
        return () => setIsNavigationPrevented(
            false
        )
    }, [isDirty, isSaving, setIsNavigationPrevented]);
    
    return (
        <>
            <div className='relative w-full h-full'>
                <div className='absolute inset-4 flex z-11 pointer-events-none'>
                    <SelectionCard ref={selectionCardRef} extractionViewerContainerRef={extractionViewerContainerRef} isViewerLoading={isViewerLoading}/>
                    <ExtractionCard selectionCardRef={selectionCardRef} isViewerLoading={isViewerLoading}/>
                </div>
                <ExtractionViewerContainer ref={extractionViewerContainerRef} isViewerLoading={setIsViewerLoading}/>
            </div>
        </>
    );
}
const ExtractionLayout: React.FC = () => (
        <ExtractionProvider>
            <ExtractionComponent />
        </ExtractionProvider>
    );

export default ExtractionLayout;